import React from 'react';
import {Form, formatter, Preloader, IPhone} from 'MWC';
import tpl from '../../templates/orderAction/form';

export default class extends Form {
    templates = {
        [this.uiStates.INITIAL]: <div />,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: (
            <div className='module-cards-order'>
                <Preloader />
            </div>
        )
    };

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL
        };

        this.sub = this.sub.bind(this);
    }

    sub(e) {
        this.submit(e);
        window.dataLayer.push({event: 'sendgreenform'});
    }

    getFormExtraData() {
        const queryParams = new URLSearchParams(this.props.location.search);
        return {
            type: this.props.type,
            utmParams: this.props.utmParams,
            utm_manager: queryParams.get('utm_manager'),
            utm_source: queryParams.get('utm_source'),
            utm_comment: queryParams.get('utm_comment'),
            utm_campaign: queryParams.get('utm_campaign'),
            utm_medium: queryParams.get('utm_medium'),
            utm_term: queryParams.get('utm_term'),
            utm_content: queryParams.get('utm_content')
        };
    }

    _phoneFormat = value => {
        if (value instanceof IPhone) {
            return value.toString('contact');
        } else {
            return formatter(value, '+{{dd}} ({{ddd}}) {{ddd}} {{dd}} {{dd}}');
        }
    };

    static displayName = 'Cards.Views.OrderForm';
}
